module.exports = __webpack_public_path__ + "static/media/visaBrand.b6bea191.png";